// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contain {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
@media (min-width: 768px) {
  .contain {
    flex-direction: row;
  }
}
.form-container {
  max-width: 600px;
  margin: 50px auto;
  background-color: #f9f9f9;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.form-container h2 {
  margin-top: 0;
  text-align: center;
}

.form-group1 {
  margin-bottom: 15px;
  width: 300px;
}

.form-group1 label {
  display: block;
  margin-bottom: 5px;
}

.form-group1 input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
}

.update-detailsAdd {
  padding: 10px;
  width: 200px;
  margin: 10px 0px 0px 50px;
  background-color: #2865aa;
  border: none;
  color: white;
  cursor: pointer;
  border-radius: 5px;
}

.update-details1:hover {
  -webkit-text-fill-color: black;
  background-color: #5390d9;
}

@media (max-width: 768px) {
  .form-container {
    padding: 15px;
    margin: 10px;
  }
  .form-group input {
    width: 100%;
  }
}
@media (max-width: 768px) {
  .main-content {
    width: 100%;
    flex-grow: 1;
  }
  .form-container {
    width: 100%;
    padding: 15px;
    margin: 10px;
  }
  .form-row {
    width: 100%;
    flex-direction: column;
  }
  .form-row1 {
    width: 100%;
    flex-direction: column;
  }
  .form-group input {
    width: 100%;
  }
  .update-details {
    width: 100%;
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/changepass.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;IACb,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;IACX,aAAa;IACb,YAAY;EACd;EACA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,SAAS;EACX;AACF","sourcesContent":[".contain {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n@media (min-width: 768px) {\n  .contain {\n    flex-direction: row;\n  }\n}\n.form-container {\n  max-width: 600px;\n  margin: 50px auto;\n  background-color: #f9f9f9;\n  padding: 20px;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.form-container h2 {\n  margin-top: 0;\n  text-align: center;\n}\n\n.form-group1 {\n  margin-bottom: 15px;\n  width: 300px;\n}\n\n.form-group1 label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.form-group1 input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-sizing: border-box;\n}\n\n.update-detailsAdd {\n  padding: 10px;\n  width: 200px;\n  margin: 10px 0px 0px 50px;\n  background-color: #2865aa;\n  border: none;\n  color: white;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n.update-details1:hover {\n  -webkit-text-fill-color: black;\n  background-color: #5390d9;\n}\n\n@media (max-width: 768px) {\n  .form-container {\n    padding: 15px;\n    margin: 10px;\n  }\n  .form-group input {\n    width: 100%;\n  }\n}\n@media (max-width: 768px) {\n  .main-content {\n    width: 100%;\n    flex-grow: 1;\n  }\n  .form-container {\n    width: 100%;\n    padding: 15px;\n    margin: 10px;\n  }\n  .form-row {\n    width: 100%;\n    flex-direction: column;\n  }\n  .form-row1 {\n    width: 100%;\n    flex-direction: column;\n  }\n  .form-group input {\n    width: 100%;\n  }\n  .update-details {\n    width: 100%;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
